import React from 'react'
import {Switch, Route} from 'react-router-dom'

// import PageShell from '../helpers/PageShell'
// import Bio from "../pages/Bio";
// import Clients from "../pages/Clients.js";
// import Contact from "../pages/Contact";
// import Expertise from "../pages/Expertise";

import Home from "../pages/Home";
import Work from "../pages/Work";
import ClientList from "../pages/ClientList";
import PropsPage from "../pages/propspass";


const Routing = () => (
  <main className="site-content">
    <Switch>
      <Route exact path="/" component={Home}/>
      <Route exact path="/work" component={Work}/>
      <Route exact path="/clientlist" component={ClientList}/>
      <Route component={Home}/>
    </Switch>
  </main>
)


export default Routing